// extracted by mini-css-extract-plugin
export default {"studio":"home_studio__4UyKG","pdfContainer":"home_pdfContainer__bVTSH"};